/* eslint-disable no-console -- logger is the single allowed console wrapper */
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  debug: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: console.error.bind(console), // Always log errors
};

export default logger;
